import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import FAQsContentAr from "./FAQsContentAr";
import FAQsContentEn from "./FAQsContentEn";
import FAQsContentFr from "./FAQsContentFr";

function FAQsPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      {lang ==='ar'? <FAQsContentAr/>:
      lang === 'fr' ? <FAQsContentFr /> : <FAQsContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default FAQsPage;
